import { createContext, contextProvider, contextProvided } from '@lit-labs/context';
export const configurationContext = createContext('config');
export { contextProvider as provider, contextProvided as consumer };
//# sourceMappingURL=context.js.map